/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/8
 * @updateTime 2021/11/8
 * @decription 复议信息基础信息mixins对应的js
 * @namespace 【b】
 */
// 请求数据
import request from './request.js';
import {mapGetters} from "vuex";
import {typeFyAjlx, typeFysx, typeTjrlx} from "@/filters";
import {ajlxRule, cBqah, FylyRule, fySqrqRule, fysx, tjrsfRule, xzfyRule} from "@/utils/validator/rules";
import validate from "@/utils/validator/validator";
export default {
    mixins: [request],
    // 依赖组件
    components: {},
    // 参数
    props: {},
    // 数据
    data() {
        return {
            // 是否显示复议事项
            showPicker: false,
            // 是否显示案件类型
            showPickerAjlx: false,
            // 是否显示提交人身份
            showPickeSQR: false,
            // 是否显示法院弹层
            showCourtPopup: false
        };
    },
    // 计算属性
    computed: {
        // 复议事项、提交人身份、案件类型
        ...mapGetters(['codeList_706000', 'codeList_118000', 'codeList_807000', 'codeList_901000']),

        /**
         * 复议事项代码值列表
         * */
        codeList_fysx() {
            // 过滤掉证据保全
            //return this.codeList_706000.filter(item => item.keyId !== '3');
            return this.codeList_706000;
        },
        /**
         * 案件类型代码值列表
         * */
        codeList_ajlx() {
            // 复议事项
            if(this.formData.nFysx == '2'){
                return this.codeList_901000;
            }
            return this.codeList_807000;
        }
    },
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 创建完成
        // 初始化代码类型值
        this.initCodeType();
    },
    // 组件激活
    activated() {
        // 激活完成
    },
    // 组件初始化完成
    mounted() {
        // 初始化完成
    },
    // 组件失去激活
    deactivated() {
        // 失去激活
    },
    // 销毁之前
    beforeDestroy() {
        // 销毁之前
    },
    // 方法
    methods: {

        /**
         * 初始化代码类型
         * @returns {void}
         * */
        initCodeType() {
            // 复议事项
            this.$store.dispatch('GetCodeType', 706000)
            // 提交人身份
            this.$store.dispatch('GetCodeType', 118000)
            // 案件类型
            this.$store.dispatch('GetCodeType', 807000)
            // 案件类型
            this.$store.dispatch('GetCodeType', 901000)
        },

        //获取基本信息的值
        getBasic(fyid, bqid){
            // 请求基本信息数据
            this.requestBasic(fyid, bqid).then(data => {
                // 表单数据赋值
                this.formData = {
                    ...this.formData,
                    ...data
                }
            })
        },

        /**
         * 获取当前日期
         * @returns {String} 当前日期
         * */
        getCurrentData() {
            let nowDate = new Date();
            var seperator1 = "-";
            var year = nowDate.getFullYear();
            var month = nowDate.getMonth() + 1;
            var strDate = nowDate.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            return year + seperator1 + month + seperator1 + strDate;
        },

        /**
         * 选择复议事项
         * @param {Object} item 复议事项数据
         * @returns {void}
         * */
        onConfirmFYSX(item){
            // 复议事项文本
            this.formData.nFysxText = item.text;
            // 复议事项
            this.formData.nFysx = item.keyId;
            // 是否显示复议事项
            this.showPicker = false;
            // 案件类型默认第一个
            this.formData.nAjlxText = this.codeList_ajlx[0].text;
            this.formData.nAjlx = this.codeList_ajlx[0].keyId;
        },

        /**
         * 选择案件类型
         * @param {Object} item 案件类型数据
         * @returns {void}
         * */
        onConfirmAjlx(item) {
            this.formData.nAjlxText = item.text;
            this.formData.nAjlx = item.keyId;
            this.showPickerAjlx = false;
        },

        /**
         * 选择提交人身份
         * @param {Object} item提交人身份数据
         * @returns {void}
         * */
        onConfirmSQR(item) {
            this.formData.cTjrlxText = item.text;
            this.formData.cTjrlx = item.keyId;
            this.showPickeSQR = false;
        },

        /**
         * 选择的法院
         * @param {Object} courtItem 法院信息项数据
         * @returns {void}
         * */
        onConfirmCourt(courtItem) {
            // 申请法院id
            this.formData.nSqfy = courtItem.id;
            // 申请法院名称赋值
            this.formData.cSqfymc = courtItem.name;
            //复议事项代码值
            const _fysxCode = courtItem.cFysx.split(',')[0];
            // 复议事项
            const _fysx = {
                keyId: _fysxCode,
                text: typeFysx(_fysxCode)
            };
            // 触发选中默认复议事项
            this.onConfirmFYSX(_fysx);
            // 隐藏法院弹层
            this.showCourtPopup = false;
        },

        /**
         * 校验基本信息
         * @param {Object} basicData 基础数据
         * @returns {Promise}
         * */
        validateBasicData(basicData) {
            let descriptor;
            descriptor = {
                // 申请法院
                nSqfy: xzfyRule,
                // 案号
                cBqah: new cBqah(true),
                // 复议事项
                nFysx: fysx,
                // 案件类型
                nAjlx: ajlxRule,
                // 提交人类型
                cTjrlx: tjrsfRule,
                // 申请日期
                dtSqrq: fySqrqRule,
                // 复议理由
                cFyky: FylyRule()
            };
            let validated = validate(descriptor, basicData);
            return validated;
        },
    }
};
